import Config from 'APP/Config'
import { Images } from 'APP/Themes'
import { ImageSourcePropType } from 'react-native'

export const getCtaAction = (
  ctaId: keyof typeof Config.MICROAPPS_CONFIG
): Record<string, unknown> => (Config.MICROAPPS_CONFIG && Config.MICROAPPS_CONFIG[ctaId]) || {}

export const getCtaIcon = (ctaId: keyof typeof Images.homeCta): ImageSourcePropType => {
  return Images.homeCta[ctaId] || Images.logoBlue
}

export const getServiceCategoryIcon = (
  iconName: keyof typeof Images.serviceCategories
): ImageSourcePropType => {
  return Images.serviceCategories[iconName] || Images.logoBlue
}

export const getServiceGroupIcon = (
  iconName: keyof typeof Images.serviceGroups
): ImageSourcePropType | undefined => {
  return Images.serviceGroups[iconName]
}
